import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetTeamReportList } from 'domain/usecases';

export class RemoteGetTeamReportList implements GetTeamReportList {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetTeamReportList.Result>,
  ) {}

  async execute(
    params: GetTeamReportList.Params,
  ): Promise<GetTeamReportList.Result> {
    const requestUrl = generateUrl(this.url, { ...params });

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
      responseType: 'json',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
